import api from '../../services/service'
import draggable from 'vuedraggable'

export default {
  data () {
    return {
      search: '',
      listRound: [],
      round_select: null,
      group_select: null,
      list_group: [],
      list_question: [],
      visible: false,
      fq_text: '',
      fq_id: null,
      Sortvisible: false,
      list_sort_question: [],
      title: '',
      choice: '',
      choice_type: '1',
      choice_other: false,
      choice_list: []
    }
  },
  components: {
    draggable
  },
  methods: {
    getRound (rs) {
      this.$store.state.isLoading = true
      this.group_select = ''
      api.getRoundList(
        result => {
          if (result.result === true) {
            this.listRound = result.data
            if (!rs) {
              this.round_select = result.data[0]
              console.clear()
            }
            this.getGroup(this.round_select)
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลแบบประเมิน',
              description: result.data
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$notification['error']({
            message: 'ดึงข้อมูลแบบประเมิน',
            description: error
          })
          this.$store.state.isLoading = false
        }
      )
    },
    selectGroup () {
      this.list_group.forEach(val => {
        if (val['group_id'] === this.group_select) {
          this.list_question = val['questions']
          this.list_sort_question = val['questions']
        }
      })
    },
    getGroup (value) {
      this.$store.state.isLoading = true
      var roundId = value
      api.getGroup(
        roundId.round_token,
        result => {
          if (result.result === true) {
            this.list_group = result.data.groups
            this.round_select = roundId
            this.group_select = this.list_group[0].group_id
            this.selectGroup()
          } else {
            console.log(result.data)
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    save () {
      if (this.fq_id) {
        var editBody = {
          quest_id: this.fq_id,
          quest_text: this.fq_text
        }
        this.updateQuest(editBody)
      } else {
        var body = {
          group_id: this.group_select,
          quest_text: this.fq_text
        }
        this.addQuest(body)
      }
    },
    handleCancel () {
      this.fq_id = ''
      this.fq_text = ''
      this.choice = ''
      this.choice_type = '1'
      this.choice_other = 0
      this.visible = false
    },
    formModal (data) {
      this.visible = true
      if (data) {
        this.title = 'แก้ไขคำถาม'
        this.fq_id = data.quest_id
        this.fq_text = data.quest_text
        this.choice = ''
        this.getchoice(data.quest_id)
      } else {
        this.title = 'เพิ่มคำถาม'
        this.choice = ''
      }
    },
    addQuest (obj) {
      this.$store.state.isLoading = true
      api.addQuestion(
        obj,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'เพิ่มข้อมูลคำถาม',
              description: 'เพิ่มคำถามเรียบร้อยแล้ว'
            })
            this.getRound(this.round_select)
          } else {
            this.$notification['warning']({
              message: 'เพิ่มข้อมูลคำถาม',
              description: result.data
            })
          }
          this.$store.state.isLoading = false
          this.handleCancel()
        },
        error => {
          this.$notification['error']({
            message: 'เพิ่มข้อมูลคำถาม',
            description: error
          })
          this.$store.state.isLoading = false
          this.handleCancel()
        }
      )
    },
    updateQuest (obj) {
      this.$store.state.isLoading = true
      api.editQuestion(
        obj,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'แก้ไขข้อมูลคำถาม',
              description: 'แก้ไขคำถามเรียบร้อยแล้ว'
            })
            this.getRound(this.round_select)
          } else {
            this.$notification['warning']({
              message: 'แก้ไขข้อมูลคำถาม',
              description: result.data
            })
          }
          this.$store.state.isLoading = false
          this.handleCancel()
        },
        error => {
          this.$notification['error']({
            message: 'แก้ไขข้อมูลคำถาม',
            description: error
          })
          this.$store.state.isLoading = false
          this.handleCancel()
        }
      )
    },
    deleteQuest (questId) {
      this.$store.state.isLoading = true
      api.removeQuestion(
        questId,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'ลบข้อมูลคำถาม',
              description: 'ลบคำถามเรียบร้อยแล้ว'
            })
            this.getRound(this.round_select)
          } else {
            this.$notification['warning']({
              message: 'ลบข้อมูลคำถาม',
              description: result.data
            })
          }
          this.$store.state.isLoading = false
          this.handleCancel()
        },
        error => {
          this.$notification['error']({
            message: 'ลบข้อมูลคำถาม',
            description: error
          })
          this.$store.state.isLoading = false
          this.handleCancel()
        }
      )
    },
    handleSortCancel () {
      this.list_sort_question = this.list_question
      this.Sortvisible = false
    },
    handleSortOk () {
      this.Sortvisible = false
      for (var i = 0; i < this.list_sort_question.length; i++) {
        this.list_sort_question[i].quest_sort = i + 1
      }
      var obj = {
        questions: this.list_sort_question
      }
      api.updateQuestsort(
        obj,
        result => {
          if (result.result === true) {
            this.$notification['success']({
              message: 'ปรับปรุงข้อมูล',
              description: 'ปรับปรุงข้อมูลกลุ่มคำถามเรียบร้อย'
            })
            this.getGroup(this.round_select)
          } else {
            this.$notification['warning']({
              message: 'ปรับปรุงข้อมูล',
              description: result.data
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    getchoice (questId) {
      this.$store.state.isLoading = true
      api.getChoiceData(
        questId,
        result => {
          if (result.result === true) {
            this.choice_list = result.data
          } else {
            console.log(result.data)
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    },
    handleChange (value) {
      this.choice_type = value
    },
    addChoice () {
      if (this.choice) {
        if (this.choice_other) {
          this.choice_other = 1
        } else {
          this.choice_other = 0
        }
        var obj = {
          answer_choice: this.choice,
          answer_choice_type: parseInt(this.choice_type),
          answer_choice_other: parseInt(this.choice_other),
          quest_id: parseInt(this.fq_id)
        }
        this.$store.state.isLoading = true
        api.addChoice(
          obj,
          result => {
            if (result.result === true) {
              this.choice = ''
              this.choice_type = '1'
              this.choice_other = false
              this.getchoice(this.fq_id)
            } else {
              console.log(result.data)
            }
            this.$store.state.isLoading = false
          },
          error => {
            this.$store.state.isLoading = false
            alert(JSON.stringify(error))
          }
        )
      }
    },
    removeChoice (choiceID) {
      this.$store.state.isLoading = true
      api.deleteChoice(
        choiceID,
        result => {
          if (result.result === true) {
            this.getchoice(this.fq_id)
          } else {
            console.log(result.data)
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          alert(JSON.stringify(error))
        }
      )
    }
  },
  computed: {
    listFilter () {
      let text = this.search.trim()
      return this.listRound.filter(round => {
        return round.title.indexOf(text) > -1 || round.year.indexOf(text) > -1
      })
    }
  },
  mounted () {
    this.setUser()
    this.getRound(this.round_select)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/question.js